import { useState } from "react";

import type { LpTaskResponse } from "@vega-api/generated/types/lpTaskResponse";
import { VegaDialog } from "@vega-core/components/Modals/VegaDialog/VegaDialog";
import { SurveyStep } from "@vega-modules/scenes/Welcome/stepsV2/SurveyStep";

type Props = {
  tasks: LpTaskResponse[];
  open: boolean;
  onClose: () => void;
};

export const SettingsFeedbackModal = ({ tasks, open, onClose }: Props) => {
  const [activeStep, setActiveStep] = useState(0);
  const [wasOpen, setWasOpen] = useState(open);

  if (open !== wasOpen) {
    setWasOpen(open);

    if (open) {
      setActiveStep(0);
    }
  }

  const currentTask = tasks.at(activeStep);

  const goToNextOrClose = () => {
    if (activeStep < tasks.length - 1) {
      setActiveStep((step) => step + 1);

      return;
    }

    onClose();
  };

  if (!currentTask) {
    return null;
  }

  return (
    <VegaDialog
      dataTestId="settings-feedback-modal"
      onClose={onClose}
      open={open}
      panelClassName="p-0 sm:max-w-xl"
    >
      <SurveyStep
        key={currentTask.id}
        onComplete={goToNextOrClose}
        task={currentTask}
      />
    </VegaDialog>
  );
};
